class AccordionTab extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    
    if (this.details && this.summary) {
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }
  
  onSummaryClick(event) {
    event.preventDefault();
    
    // Close all other accordion items (single select behavior)
    const accordionWrapper = this.closest('.accordion-wrapper');
    if (accordionWrapper) {
      const allAccordions = accordionWrapper.querySelectorAll('accordion-tab details[open]');
      allAccordions.forEach(accordion => {
        if (accordion !== this.details) {
          accordion.removeAttribute('open');
        }
      });
    }
    
    if (this.details.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    this.details.setAttribute('open', '');
    this.details.style.height = 'auto';
    
    // Animate the content
    const content = this.details.querySelector('.accordion__content');
    if (content) {
      content.style.animation = 'accordion-open 0.3s ease';
    }
  }
  
  close() {
    this.details.removeAttribute('open');
    
    // Add closing animation
    const content = this.details.querySelector('.accordion__content');
    if (content) {
      content.style.animation = 'accordion-close 0.3s ease';
    }
  }
}

customElements.define('accordion-tab', AccordionTab);
